
import { Button } from '@mui/material';
import styles from './Buttons.module.scss';

interface Props {
    id: string;
    label: string;
    onclickHandler: any;
    disabled?:boolean;
}

export default function SuccessButton ({id, label, onclickHandler, disabled}: Props){
    return (
        <Button
            id={id}
            size="small"
            className={[styles.btn, styles.normalButton].join(" ")}
            onClick={onclickHandler}
            variant="contained"
            color='success'
            disabled={disabled}
        >
            {label}
        </Button>
    );
}